import React from 'react';

interface Props {
  title: string;
  rightContent?: React.ReactNode;
}

export const HeaderBar: React.FC<Props> = ({ title, rightContent }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px 10px',
    flexShrink: 0,
  }}>
    <span style={{ fontWeight: 600, fontSize: 17, color: 'var(--bl-text)' }}>
      {title}
    </span>
    {rightContent && <div>{rightContent}</div>}
  </div>
);
